import { IHttpService, IPromise, IHttpResponse } from 'angular';
// @ts-ignore
import LRUCache from 'lru-cache';

function debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: any;
    return function (...args: any[]) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

interface CacheEntry<T> {
    response: IHttpResponse<T>;
}

export class HttpCacheService {
    private cache: LRUCache<string, CacheEntry<any>>;
    private debouncedClearCache: (...args: any[]) => void;

    static $inject = ['$http'];

    constructor(private $http: IHttpService) {
        this.cache = new LRUCache<string, CacheEntry<any>>({
            max: 100,
            ttl: 15 * 60 * 1000
        });

        this.debouncedClearCache = debounce(this.clearCacheExceptForX.bind(this), 1000);
    }

    extractContractId(url: string): string | null {
        const regex = /\/contract\/([a-f0-9-]+)\//;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    private clearCacheExceptForX(url: string): void {
        const exclusions = [
            '/submittability_report',
        ];

        const shouldClearCache = !exclusions.some(exclusion => {
            return url.includes(exclusion);
        });

        if (shouldClearCache) {
            setTimeout(() => {
                this.cache.reset();
            }, 0);
            console.log(`Cache cleared for all URLs except those containing '/submittability_report' or matching '/contract/<UUID>/file/<UUID>'.`);
        } else {
            console.log(`Cache not cleared for URL: ${url}`);
        }
    }

    public get<T>(url: string, config?: any): IPromise<IHttpResponse<T>> {
        /* Disabled
        if (url.includes('/file') || url.includes('/admin')) {
            console.log(`No caching for URL containing '/file and /admin': ${url}`);
            return this.$http.get<T>(url, config);
        }

        const cachedResponse = this.cache.get(url);

        if (cachedResponse) {
            console.log(`Serving from cache for URL: ${url}`);
            return Promise.resolve(cachedResponse.response) as IPromise<IHttpResponse<T>>;
        }
        */
        return this.$http.get<T>(url, config).then((response: IHttpResponse<T>) => {
            //console.log(`Caching response for URL: ${url}`);
            //this.cache.set(url, { response });
            return response;
        });
    }

    public post<T>(url: string, data: any, config?: any): IPromise<IHttpResponse<T>> {
        this.debouncedClearCache(url);
        console.log(`POST request sent to URL: ${url} - Cache cleared`);
        return this.$http.post<T>(url, data, config);
    }

    public put<T>(url: string, data: any, config?: any): IPromise<IHttpResponse<T>> {
        this.debouncedClearCache(url);
        console.log(`PUT request sent to URL: ${url} - Cache cleared`);
        return this.$http.put<T>(url, data, config);
    }

    public delete<T>(url: string, config?: any): IPromise<IHttpResponse<T>> {
        this.debouncedClearCache(url);
        console.log(`DELETE request sent to URL: ${url} - Cache cleared`);
        return this.$http.delete<T>(url, config);
    }
}